import Vue from "vue";
import App from "./App.vue";
import Buefy from "buefy";
import VueI18n from "vue-i18n";
import VueAnalytics from "vue-analytics";
import "./assets/scss/app.scss";
import "./assets/scss/sinacherib.scss";

Vue.use(Buefy);
Vue.use(VueI18n);
Vue.use(VueAnalytics, {
  id: "UA-140821660-3",
  autoTracking: {
    screenview: true
  }
});
Vue.config.productionTip = false;

const i18n = new VueI18n({
  fallbackLocale: "ja",
  locale: "en",
  messages: {
    ja: require("@/locales/ja.json"),
    en: require("@/locales/en.json")
  }
});

new Vue({
  render: h => h(App),
  i18n
}).$mount("#app");
